import { ArrowRightOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import Accordion from 'components/Accordion';
import TaskInfo from 'components/TaskInfo';
import { routes } from 'routes/AllRoutes';
import { PgData, SeasonOption } from 'screens/farmer/hooks/useFarmerPgs';
import { renderDate, renderInfoValue } from 'utils/helpers';

interface PlantingGroupsTabProps {
  pgOptions: SeasonOption[];
  selectedSeason?: SeasonOption;
  setSelectedSeason: (season: SeasonOption) => void;
  currentSeason?: string;
}

const PlantingGroupsTab: React.FC<PlantingGroupsTabProps> = ({
  pgOptions,
  selectedSeason,
  setSelectedSeason,
  currentSeason,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {pgOptions?.length > 0 ? (
        pgOptions.map((each) => {
          const key = each?.label;
          return (
            <Accordion
              key={key}
              title={each?.label}
              style={{ marginBottom: '12px' }}
              itemKey={key}
              isActive={each?.label === selectedSeason?.label}
              onChange={() => setSelectedSeason(each)}
              activeKey={selectedSeason?.label}
            >
              {each?.pgData?.length > 0 ? (
                each?.pgData?.map((pg: PgData, index: number) => (
                  <Flex
                    wrap="wrap"
                    style={{
                      rowGap: 10,
                      padding: '16px 0px 8px',
                      borderBottom:
                        index < (each.pgData?.length ?? 0) - 1
                          ? '1px solid #e8e8e8'
                          : 'none',
                    }}
                    key={pg.id || pg.seasonId || Math.random().toString()}
                  >
                    <TaskInfo
                      header={'Planting Group Name'}
                      renderValue={() => renderInfoValue(pg?.seasonName, '-')}
                    />
                    <TaskInfo
                      header={'ALM Type'}
                      renderValue={() => renderInfoValue(pg?.almType, '-')}
                    />
                    <TaskInfo
                      header={'Estimated Start Date'}
                      renderValue={() =>
                        renderDate(pg?.estimateStartDate, '-', 'DD MMM YYYY')
                      }
                    />
                    <TaskInfo
                      header={'Estimated Harvest Date'}
                      renderValue={() =>
                        renderDate(pg?.estimateEndDate, '-', 'DD MMM YYYY')
                      }
                    />
                    {each?.label === currentSeason && pg?.seasonId && (
                      <div
                        className="fgl-link-text"
                        style={{ display: 'flex', alignItems: 'center' }}
                        onClick={() =>
                          navigate(routes.awdProgress, {
                            state: { seasonId: pg.seasonId },
                          })
                        }
                      >
                        <Typography
                          className="fgl-link-text"
                          style={{ marginRight: '4px' }}
                        >
                          Go to Planting group
                        </Typography>
                        <ArrowRightOutlined />
                      </div>
                    )}
                  </Flex>
                ))
              ) : (
                <Typography.Text>No Planting Groups Found</Typography.Text>
              )}
            </Accordion>
          );
        })
      ) : (
        <Typography.Text>No Seasons Available</Typography.Text>
      )}
    </>
  );
};

export default PlantingGroupsTab;
